import React from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import { MmsPipelineStepStatus } from "../../../../../../utils/mmsOnboardingApi";
import s from "./mmsPipelineStepList.scss";

interface MmsPipelineStepListProps {
  steps: MmsPipelineStepStatus[];
}

function StepIcon({ status }: { status: MmsPipelineStepStatus["status"] }) {
  if (status === "complete") {
    return (
      <div className={s.iconComplete}>
        <i className="fas fa-check" aria-hidden="true" />
      </div>
    );
  }
  if (status === "failed") {
    return (
      <div className={s.iconFailed}>
        <i className="fas fa-times" aria-hidden="true" />
      </div>
    );
  }
  if (status === "blocked") {
    return (
      <div className={s.iconBlocked}>
        <i className="fas fa-exclamation" aria-hidden="true" />
      </div>
    );
  }
  if (status === "in_progress") {
    return (
      <div className={s.iconProgress}>
        <i className="fas fa-spinner fa-spin" aria-hidden="true" />
      </div>
    );
  }
  return (
    <div className={s.iconPending}>
      <i className="fas fa-circle" aria-hidden="true" />
    </div>
  );
}

const MmsPipelineStepList: React.FC<MmsPipelineStepListProps> = ({ steps }) => {
  return (
    <div className={s.list}>
      {steps.map((step, idx) => (
        <div
          key={step.id}
          className={s.row}
          style={{
            paddingTop: idx === 0 ? 0 : undefined,
            paddingBottom: idx === steps.length - 1 ? 0 : undefined,
            borderBottom: idx === steps.length - 1 ? "none" : undefined,
          }}
        >
          <StepIcon status={step.status} />
          <span className={s.label}>{step.label}</span>
        </div>
      ))}
    </div>
  );
};

export default withStyles(s)(MmsPipelineStepList);
